'use client'

import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import Reveal from '../Reveal'

const faqs = [
  {
    q: 'Do I have to sell my crypto to get a loan?',
    a: 'No. You pledge your crypto as collateral and borrow against it. You keep full ownership and all the upside if the price rises — repay the loan and your collateral is returned in full.',
  },
  {
    q: 'Is there a credit check?',
    a: 'Never. Your loan is secured by your collateral, not your credit history. Approval is instant and does not affect your credit score.',
  },
  {
    q: 'What happens if the market drops?',
    a: 'We monitor your loan-to-value in real time. If the market falls, you can top up collateral or repay part of the loan to stay healthy. Liquidation only occurs if LTV crosses the safety threshold, and we alert you well in advance.',
  },
  {
    q: 'How fast will I receive funds?',
    a: 'Once your collateral is confirmed on-chain, funds are typically disbursed in under two minutes to your wallet or linked bank account.',
  },
  {
    q: 'Are there any prepayment penalties?',
    a: 'None. Repay early, partially, or in full at any time with zero fees. You only pay interest for the time you actually borrow.',
  },
  {
    q: 'Which countries do you support?',
    a: 'Crypto Credits is available in 40+ countries across North America, Europe, LATAM and APAC. Region-specific terms are shown at signup.',
  },
]

function Item({ q, a, i }: { q: string; a: string; i: number }) {
  const [open, setOpen] = useState(i === 0)
  return (
    <Reveal delay={i * 0.05}>
      <div className="glass rounded-2xl overflow-hidden">
        <button
          onClick={() => setOpen((o) => !o)}
          className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
        >
          <span className="font-medium text-white">{q}</span>
          <span
            className={`shrink-0 w-8 h-8 rounded-lg flex items-center justify-center transition-all ${
              open ? 'bg-electric-500/20 text-electric-300 rotate-45' : 'text-steel-400'
            }`}
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" d="M12 4v16m8-8H4" />
            </svg>
          </span>
        </button>
        <AnimatePresence>
          {open && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: 'auto', opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.3 }}
              className="overflow-hidden"
            >
              <p className="px-6 pb-5 text-sm text-steel-300 leading-relaxed">{a}</p>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </Reveal>
  )
}

export default function FAQ() {
  return (
    <section id="faq" className="relative py-24">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center mb-14">
          <p className="text-xs tracking-[0.3em] text-electric-400 uppercase mb-3">
            Questions, answered
          </p>
          <h2 className="font-display font-bold text-3xl sm:text-4xl text-chrome">
            Frequently asked
          </h2>
        </Reveal>
        <div className="space-y-3">
          {faqs.map((f, i) => (
            <Item key={f.q} q={f.q} a={f.a} i={i} />
          ))}
        </div>
      </div>
    </section>
  )
}
